import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setActionsAction } from '../../reducers/actions';
import { ActionService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_ACTIONS),
    switchMap(action =>
      ActionService.getByTriggerId(action.triggerId, store).pipe(
        map(data => setActionsAction(data)),
        catchError(retryAuthentication(action$, 'epics/actions/getActions'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/actions/getActions.js